import { TabStyles } from '@tableau/widgets';
import { cssClass } from '../../../style';
import { CommonStyles } from '../../../common/react/CommonStyles';

const updateSiteLogoFormBorderWidth = 1;
const updateSiteLogoFormInnerWidth = 600 - updateSiteLogoFormBorderWidth*2;

const updateSiteLogoFormInnerNavPanelWidth = 240; //  from NavigationStyles OpenPanelWidth
const updateSiteLogoFormInnerMinimizedNavPanelWidth = 66; // From NavigationStyles MinimizedPanelWidth

export namespace FormStyles {

  export const errorStateBackgroundColor = CommonStyles.Colors.Grey245;
  export const defaultStateBackgroundColor = TabStyles.Colors.White;

  export const pointerCursor: React.CSSProperties = {
    cursor: 'pointer',
  };

  export const buttonSpacing: React.CSSProperties = {
    marginLeft: TabStyles.Spacing.SmallSpace,
    marginRight: TabStyles.Spacing.SmallSpace,
    ...pointerCursor,
  };

  export const centerAlignText: React.CSSProperties = {
    textAlign: 'center'
  };

  export const centerJustifyContent: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
  };

  export const alignFormContent: React.CSSProperties = {
    marginBottom: 20,
    marginTop: 20,
    verticalAlign: 'middle',
    ...centerJustifyContent
  };

  export const updateLogoRegionStyles: React.CSSProperties = {
    position: 'relative',
    width: updateSiteLogoFormInnerWidth,
    height: 'auto',
    borderWidth: updateSiteLogoFormBorderWidth,
    borderStyle: 'solid',
    borderColor: CommonStyles.Colors.Grey225,
    ...centerAlignText
  };

  export const displayFilenameTextStyles: React.CSSProperties = {
    width: updateSiteLogoFormInnerWidth - TabStyles.Spacing.ExtraLargeSpace*2,
    paddingTop: TabStyles.Spacing.ExtraLargeSpace,
    paddingBottom: TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
    paddingRight: TabStyles.Spacing.ExtraLargeSpace,
    fontSize: 20,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };

  export const errorTextStyles: React.CSSProperties = {
    paddingTop: 0,
    color: TabStyles.Colors.AttentionDark,
  };

  export const previewTextPadding: React.CSSProperties = {
    marginBottom: 10,
    marginTop: 40
  };

  export const previewDropTargetPadding: React.CSSProperties = {
    marginLeft: 10,
    marginRight: 10
  };

  export const doNotDisplay: React.CSSProperties = {
    display: 'none'
  };

  const logoPreviewStyles: React.CSSProperties = {
    backgroundColor: CommonStyles.Colors.Grey250, // from NavigationStyles LeftPanel background color
    paddingTop: 28,  // from NavigationStyles LeftPanel paddingTop
    paddingBottom: 24, // from NavigationStyles LogoMarginBottom
    display: 'flex',
    justifyContent: 'center'
  };

  export const headerLogoPreviewClass = cssClass('HeaderLogoPreview','', {
    width: updateSiteLogoFormInnerNavPanelWidth,
    ...logoPreviewStyles
  });

  export const compactLogoPreviewClass = cssClass('CompactLogoPreview', '', {
    width: updateSiteLogoFormInnerMinimizedNavPanelWidth,
    ...logoPreviewStyles
  });

  export const dropTargetHighlightingClass = cssClass('LogoPreview', '', {
    backgroundColor: CommonStyles.Colors.HyperlinkBlueHover,
  });
}
